import {searchReportHTML, searchReport, searchReportById} from '../reports/reports.api';

// #region Globals
const CONTEXT_BASE_PATH = 'espaciosprotegidos/pdf';
const CONTEXT_BASE_HTML_PATH = 'espaciosprotegidos/html';
const CONTEXT_SINGLE_BASE_PATH = 'espaciosprotegidos/pdfindividual';
// #endregion

// #region Public functions
async function getProtectedAreaPdf(id) {
  return searchReportById(id, CONTEXT_SINGLE_BASE_PATH);
}
async function searchProtectedAreaPdf(searchParams = {}) {
  return searchReport(searchParams, CONTEXT_BASE_PATH);
}
async function searchProtectedAreaHtml(searchParams = {}) {
  return searchReportHTML(searchParams, CONTEXT_BASE_HTML_PATH);
}

// #endregion

// #region Private functions
// ...
// #endregion

export {
  getProtectedAreaPdf,
  searchProtectedAreaPdf,
  searchProtectedAreaHtml,
};
